import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { euro, practiceApi } from "../../lib/practiceApi";
import { localToday } from "../practices/stageForm";

export const InvoiceDraftDialog = ({ draft, onClose, onConfirmed }) => {
  const [number, setNumber] = useState(draft.invoice_number || "");
  const [date, setDate] = useState(draft.invoice_date || localToday());
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  async function confirm(event) {
    event.preventDefault(); setBusy(true); setError("");
    try {
      await practiceApi(`/billing/drafts/${draft.id}/invoiced`, { method: "POST", body: JSON.stringify({ number, date }) });
      window.dispatchEvent(new Event("billing-updated"));
      await onConfirmed(); onClose();
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  return <Dialog open onOpenChange={open => { if (!open && !busy) onClose(); }}>
    <DialogContent className="installment-dialog" data-testid="installment-invoice-dialog" closeTestId="installment-invoice-close">
      <DialogHeader><DialogTitle>{draft.installment_number ? `Bozza fattura · rata ${draft.installment_number}` : "Bozza fattura"}</DialogTitle><DialogDescription>{draft.practice_name || draft.description}</DialogDescription></DialogHeader>
      <dl className="installment-invoice-details">
        <div><dt>Cliente</dt><dd data-testid="installment-invoice-client">{draft.client_name || "Committente da associare"}</dd></div>
        <div><dt>Importo rata</dt><dd data-testid="installment-invoice-amount">{euro(draft.amount)}</dd></div>
      </dl>
      <label>Causale<textarea readOnly rows={3} data-testid="installment-invoice-description" value={draft.description || ""} /></label>
      <form onSubmit={confirm}>
        <div className="practice-form-grid">
          <label>Numero della fattura emessa<input required maxLength={40} data-testid="installment-invoice-number" disabled={busy} value={number} onChange={e => setNumber(e.target.value)} /></label>
          <label>Data fattura<input type="date" required max={localToday()} data-testid="installment-invoice-date" disabled={busy} value={date} onChange={e => setDate(e.target.value)} /></label>
        </div>
        <p className="muted installment-note" data-testid="installment-invoice-internal">Bozza interna · nessun invio fiscale automatico. La conferma non registra un incasso.</p>
        {error && <p className="error" role="alert" data-testid="installment-invoice-error">{error}</p>}
        <div className="practice-inline-actions"><button type="button" className="ghost" disabled={busy} data-testid="installment-invoice-cancel" onClick={onClose}>Chiudi bozza</button>
          <button type="submit" className="primary" disabled={busy} data-testid="installment-invoice-confirm">{busy ? "Registrazione…" : "Registra fattura emessa"}</button></div>
      </form>
    </DialogContent>
  </Dialog>;
};